
document.addEventListener("DOMContentLoaded", function() {
    let heroAni = gsap.timeline()
        .from('.animated-con > div, .animated-con > div h1, .animated-con > div h2, .animated-con > div p, .animated-con .btn-group > div', { yPercent: 101, duration: 1, stagger: 0.5 })
        // .from('.animated-con .btn-group > div .btn',{scaleX: 0.2, scaleY: 1, borderRadius:0, duration: 1, stagger: 0.5})
        // .from('.animated-con .btn-group > div .btn-text',{opacity: 0, duration: 1});

    let mm = gsap.matchMedia();
    mm.add("(max-width:767px)", () => {
        gsap.to(".topbar-main", {
            y: -29, 
            delay: 5,
            duration: 2, 
            ease: "none",
            repeat: -1, 
            yoyo: true, 
            repeatDelay: 5,
        });
    });

    gsap.registerPlugin(ScrollTrigger);

 
    mm.add("(min-width:768px)", () => {

        // Image with text transform text 

        let secWidth = window.innerWidth;
        let firstSec = document.querySelector('.image-text-tran-animation .image-block');
        let firstSecWidth = firstSec ? firstSec.offsetWidth : 0;


        let mytl = gsap.timeline()
        .fromTo(".img-text-wrapper",{x: 1*secWidth},{x: -1*firstSecWidth, duration: 1, ease: "none"})

        let mySt = ScrollTrigger.create({
            animation: mytl,
            trigger: ".img-text-wrapper",
            pin:true,
            start: "top top",
            scrub: true,
            markers: false,
        });
       
        let splitTimeline = gsap.timeline({
            onComplete: function () {
                splitSt.refresh();
            }
        });

        // Smooth scaling animation for .split-banner
        splitTimeline.fromTo(
            ".split-banner-animation .split-banner.banner-split",
            { maxWidth: "1350px",paddingBlock: "25px" },
            {
                maxWidth: "100%",
                paddingBlock: "0px",
                duration: 1.5, 
                ease: "none" 
            }
        );
        
        let splitSt = ScrollTrigger.create({
            animation: splitTimeline,
            trigger: ".split-banner-animation", 
            start: "top 70%", 
            end: "bottom 120%", 
            scrub: 1, 
            markers: false 
        });
    });

    // story banner animation
    let storyTimeline = gsap.timeline()
    .fromTo(".about-banner-animation .banner-img", 
        { maxWidth: "100%" }, 
        { maxWidth: "800px", duration: 8, ease: "none", 
          onComplete: () => {
              // Refresh the grid card animation when storyTimeline completes
              ScrollTrigger.refresh();
             //r gridCardTimeline.restart(); // Restart gridCardTimeline if needed
          }
        });

    let storySt = ScrollTrigger.create({
        animation: storyTimeline,
        trigger: ".about-banner-animation .banner-img",
        start: "top 60%",
        end: "+=60%",
        scrub: 2,
        markers: false,
    });

         

mm.add("(min-width: 992px)", () => {
  gsap.utils.toArray(".image-text-animation-top").forEach(section => {
    const img = section.querySelector(".section-img");
    const block = section.querySelector(".inside-block");

    if (img) {
      gsap.fromTo(
        img,
        { y: -50 },
        {
          y: 0,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top 25%",
            end: "bottom-=90 50%",
            scrub: true,
            markers: false,
          },
        }
      );
    }

    if (block) {
      gsap.from(
        block,
        { y: 0 },
        {
          y: -50,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top 25%",
            end: "bottom-=90 50%",
            scrub: true,
            markers: false,
          },
        }
      );
    }
  });
});

  // Footer Grid Card
    // Declare globally to avoid ReferenceError
    mm.add("(min-width:768px)", () => {
        let prallexCard = document.querySelectorAll('.grid-list');
        let gridCardTimeline = gsap.timeline()
        .to(prallexCard, { margin: "0", duration: 1, ease: "none" });
        ScrollTrigger.create({
            animation: gridCardTimeline,
            trigger: ".grid-group",
            start: "top 80%",
            end: "bottom-=90 100%",
            scrub: 1,
            markers: false,
        });
    });

    mm.add("(max-width: 767px)", () => {
        const sec = document.querySelector(".img-text-wrapper");
        if (!sec) return; // Ensure element exists to prevent errors
        const secWidth = sec.offsetWidth;
        gsap.fromTo(
            sec,
            { x: 150 },
            {
                x: -(secWidth + 50),
                duration: 5,
                ease: "none",
                scrollTrigger: {
                    trigger: sec,
                    start: "top 70%",
                    end: "top 20%",
                    scrub: 1,
                    markers: false,
                }
            }
        );
    });
});